'use client'

import CustomModal from '@/components/UI/Modal/CustomModal/CustomModal'
import { useModalStore } from '@/stores/useModalStore'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export default function ModalHost() {
  const { isOpen, type, content, closeOnBackdrop, closeModal } = useModalStore()
  const pathname = usePathname()

  useEffect(() => {
    const element = document.documentElement
    if (isOpen) element.classList.add('modal-open')
    else element.classList.remove('modal-open')

    return () => {
      element.classList.remove('modal-open')
    }
  }, [isOpen])

  useEffect(() => {
    if(isOpen) {
      closeModal()
    }
  }, [pathname])

  if (!isOpen || !content) return null

  

  return (
    <CustomModal
      type={type}
      onClose={closeModal}
      closeOnBackdrop={closeOnBackdrop}
    >
      {content}
    </CustomModal>
  )
}